
import React from 'react';

export const ServicesSection: React.FC = () => {
  const services = [
    {
      icon: 'ri-building-line',
      title: 'Abertura e Regularização de Empresas',
      description: 'Constituição, registro, CNPJ e licenças',
      features: ['Análise de viabilidade', 'Registro na Junta Comercial', 'Obtenção de licenças', 'Inscrições fiscais']
    },
    {
      icon: 'ri-bar-chart-line',
      title: 'Contabilidade Gerencial',
      description: 'Balancetes, DRE, balanços e relatórios gerenciais',
      features: ['Demonstrações financeiras', 'Análise de indicadores', 'Relatórios customizados', 'Controle patrimonial']
    },
    {
      icon: 'ri-calculator-line',
      title: 'Planejamento Tributário',
      description: 'Definição do regime ideal e redução de carga tributária',
      features: ['Análise de regime tributário', 'Elisão fiscal', 'Simulações tributárias', 'Otimização de impostos']
    },
    {
      icon: 'ri-team-line',
      title: 'Departamento Pessoal',
      description: 'Folha, eSocial, admissões e demissões',
      features: ['Folha de pagamento', 'Admissões e demissões', 'eSocial e FGTS', 'Benefícios e férias']
    },
    {
      icon: 'ri-file-text-line',
      title: 'Obrigações Acessórias',
      description: 'SPED, DCTF, DEFIS, ECD, ECF e declarações fiscais',
      features: ['SPED Fiscal e Contábil', 'Declarações federais', 'Obrigações estaduais', 'Prazos e alertas']
    },
    {
      icon: 'ri-money-dollar-circle-line',
      title: 'Assessoria Fiscal',
      description: 'Apuração de impostos e emissão de guias',
      features: ['Apuração de impostos', 'Emissão de guias', 'Parcelamentos', 'Defesas e recursos']
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Consultoria Empresarial',
      description: 'Viabilidade, reestruturação e gestão financeira',
      features: ['Análise de viabilidade', 'Reestruturação societária', 'Gestão financeira', 'Planejamento estratégico']
    },
    {
      icon: 'ri-computer-line',
      title: 'Contabilidade Digital',
      description: 'Acesso online aos principais indicadores do negócio',
      features: ['Portal do cliente', 'Relatórios online', 'Indicadores em tempo real', 'Backup em nuvem']
    }
  ];

  return (
    <section id="servicos" className="py-20 bg-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-[#1A3A52] mb-6 font-['Playfair_Display']">
            Nossos Serviços
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Oferecemos soluções completas em contabilidade, tributação e gestão empresarial 
            para impulsionar o crescimento do seu negócio
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 bg-[#00A896] rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${service.icon} text-white text-2xl`}></i>
              </div>
              
              <h4 className="text-lg font-semibold text-[#1A3A52] mb-3 text-center">
                {service.title}
              </h4>
              
              <p className="text-gray-600 text-sm mb-4 text-center">
                {service.description}
              </p>
              
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-[#00A896] mr-2 text-xs"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-lg text-gray-600 mb-6">
            Precisa de um serviço específico? Entre em contato conosco!
          </p>
          <button 
            onClick={() => window.open('https://wa.me/5541996543210', '_blank')}
            className="bg-[#25D366] hover:bg-[#20B858] text-white px-8 py-4 rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-2"></i>
            Solicitar Orçamento
          </button>
        </div>
      </div>
    </section>
  );
};
